const backgroundStyles = [
    {
        path: 'style/backgroundColor',
        content: {
            hoverable: true,
            inputType: 'color',
            placeholder: 'eg: #ff00ff',
            label: 'Background Color',
            template: 'ColorPicker',
        },
        conditions: [
            ['settings/activeBgStyle', '===', undefined],
            '||',
            ['settings/activeBgStyle', '===', 'color'],
        ],
    },
    {
        path: 'style/backgroundImage/gradient',
        conditions: ['settings/activeBgStyle', '===', 'gradient'],
        resetDep: false,
        dependentsValue: {
            'style/backgroundRepeat': 'no-repeat',
        },
    },
    {
        conditions: ['settings/activeBgStyle', '===', 'image'],
        modules: [
            {
                resetDep: false,
                path: 'style/backgroundImage/image',
                dependentsValue: {
                    'style/backgroundSize': 'cover',
                    'style/backgroundPosition': 'center',
                    'style/backgroundRepeat': 'no-repeat',
                },
            },
            // {
            //     path: 'style/asdfasdf',
            //     content: {
            //         onValue: true,
            //         onLabel: 'ON',
            //         offValue: false,
            //         offLabel: 'OFF',
            //         template: 'Switch',
            //         defaultValue: false,
            //         label: 'Parallax / Fixed Background',
            //     },
            // },
            'style/backgroundSize',
            'style/backgroundPosition',
            'style/backgroundRepeat',
            'style/backgroundBlendMode',
            'attr/__class__overlayType',
            {
                path: 'pseudoClass/before/style/backgroundColor',
                conditions: [
                    'attr/__class__overlayType',
                    '===',
                    'color-overlay',
                ],
                content: {
                    template: 'ColorPicker',
                    placeholder: 'eg: #ff00ff',
                },
            },
            {
                path: 'pseudoClass/before/style/backgroundImage/gradient',
                conditions: [
                    'attr/__class__overlayType',
                    '===',
                    'gradient-overlay',
                ],
                content: {
                    template: 'BackgroundGradient',
                },
            },
        ],
    },
];

export default backgroundStyles;

export function prefixBackgroundStyle(prefix) {
    return backgroundStyles.map((item) => {
        const stripedPath = item.path?.split('/').slice(1).join('/');
        const path = `${prefix}/${stripedPath}`;
        return { ...item, path };
    });
}
